import Lottie from "lottie-react";
import loadingClock from "./loading-clock.json";

export default function SubscriptionActivationPending() {
    return (
        <div
            className="loading-page-center"
            style={{
                flexDirection: "column",
                minHeight: "80vh",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "20px",
            }}
        >
            <Lottie animationData={loadingClock} loop />
            <h2 style={{ color: "#00087a", fontWeight: 700 }}>
                Subscription Activation Pending
            </h2>
            <p style={{ marginTop: "1rem", color: "#333", fontSize: "18px" }}>
                We&apos;re finishing up your payment. This may take a couple of
                minutes.
                <br />
                <br />
                <b>Mobile:</b> Switch to your HabitNu app to check your
                subscription status.
                <br />
                <br />
                <b>Web:</b> Please{" "}
                <a href="/">
                    <b>Login</b>
                </a>{" "}
                to view your subscription status.
                <br />
                <br />
                If it takes more than 10 minutes, please reach out to us at{" "}
                <b>support@habitnu.in</b>.
            </p>
        </div>
    );
}
